import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { F8858SchdC1Component } from './components/f8858-schd-c1/f8858-schd-c1.component';
import { F8858SchdC1Service } from './services/f8858-schd-c1.service';

@NgModule({
  declarations: [
    F8858SchdC1Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    F8858SchdC1Component
  ],
  providers: [
    F8858SchdC1Service
  ]
})
export class Fir8858Module { }

